var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.block.attributes.visible || _vm.canEdit
    ? _c(
        "div",
        {
          staticClass: "cw-default-block",
          class: [_vm.showEditMode ? "cw-default-block-active" : ""],
        },
        [
          _c(
            "div",
            {
              staticClass: "cw-content-wrapper",
              class: [_vm.showEditMode ? "cw-content-wrapper-active" : ""],
            },
            [
              _vm.showEditMode
                ? _c(
                    "header",
                    {
                      staticClass: "cw-block-header",
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "cw-block-header-toggle",
                          attrs: {
                            href: "#",
                            "aria-expanded": _vm.isOpen,
                          },
                          on: {
                            click: function click($event) {
                              $event.preventDefault()
                              _vm.isOpen = !_vm.isOpen
                            },
                          },
                        },
                        [
                          _c("studip-icon", {
                            attrs: {
                              shape: _vm.isOpen ? "arr_1down" : "arr_1right",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.blockTitle))]),
                          _vm._v(" "),
                          _vm.blockedByAnotherUser
                            ? _c("studip-icon", {
                                attrs: {
                                  shape: "lock-locked",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.blockedByAnotherUser
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "cw-default-block-blocker-warning",
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$gettextInterpolate(
                                          _vm.$gettext(
                                            "Wird im Moment von %{ userName } bearbeitet"
                                          ),
                                          {
                                            userName: this.blockingUserName,
                                          }
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.block.attributes.visible
                            ? _c("studip-icon", {
                                attrs: {
                                  shape: "visibility-invisible",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.block.attributes.visible
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "cw-default-block-invisible-info",
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$gettext(
                                          "Unsichtbar für Nutzende ohne Schreibrecht"
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("courseware-block-actions", {
                        attrs: {
                          block: _vm.block,
                          canEdit: _vm.canEdit,
                          deleteOnly: _vm.deleteOnly,
                        },
                        on: {
                          editBlock: function editBlock($event) {
                            return _vm.displayFeature("Edit")
                          },
                          showInfo: function showInfo($event) {
                            return _vm.displayFeature("Info")
                          },
                          showExportOptions: function showExportOptions(
                            $event
                          ) {
                            return _vm.displayFeature("ExportOptions")
                          },
                          deleteBlock: function deleteBlock($event) {
                            return _vm.displayDeleteDialog()
                          },
                          removeLock: function removeLock($event) {
                            return _vm.displayRemoveLockDialog()
                          },
                          copyToClipboard: _vm.copyToClipboard,
                          deactivateComments: _vm.deactivateComments,
                          activateComments: _vm.activateComments,
                          showFeedback: _vm.showFeedback,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isOpen,
                      expression: "isOpen",
                    },
                  ],
                },
                [
                  _vm.showContent
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-content",
                        },
                        [_vm._t("content")],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showFeatures
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "cw-block-features cw-block-features-default",
                        },
                        [
                          _vm.canEdit && _vm.showExportOptions
                            ? _c("courseware-block-export-options", {
                                attrs: {
                                  block: _vm.block,
                                },
                                on: {
                                  close: function close($event) {
                                    return _vm.displayFeature(false)
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canEdit && _vm.showEdit
                            ? _c("courseware-block-edit", {
                                attrs: {
                                  block: _vm.block,
                                  preview: _vm.preview,
                                },
                                on: {
                                  store: _vm.prepareStoreEdit,
                                  close: _vm.closeEdit,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "edit",
                                      fn: function fn() {
                                        return [_vm._t("edit")]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showInfo
                            ? _c("courseware-block-info", {
                                attrs: {
                                  block: _vm.block,
                                },
                                on: {
                                  close: function close($event) {
                                    return _vm.displayFeature(false)
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "info",
                                      fn: function fn() {
                                        return [_vm._t("info")]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("courseware-block-discussion", {
            attrs: {
              block: _vm.block,
              canEdit: _vm.canEdit,
              commentable: _vm.commentable,
              displayFeedback: _vm.displayFeedback,
            },
          }),
          _vm._v(" "),
          _vm.showDeleteDialog
            ? _c("studip-dialog", {
                attrs: {
                  title: _vm.textDeleteTitle,
                  question: _vm.textDeleteAlert,
                  height: "180",
                  width: "360",
                },
                on: {
                  confirm: _vm.executeDelete,
                  close: _vm.closeDeleteDialog,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showRemoveLockDialog
            ? _c("studip-dialog", {
                attrs: {
                  title: _vm.textRemoveLockTitle,
                  question: _vm.textRemoveLockAlert,
                  height: "200",
                  width: "450",
                },
                on: {
                  confirm: _vm.executeRemoveLock,
                  close: function close($event) {
                    _vm.showRemoveLockDialog = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }